<template>
  <div :class="customClass ? `row mt-20 mb-10 ${customClass}` : 'row mt-20 mb-10'">
    <div class="col-sm-6">
      <h3 class="main-title">{{title}}</h3>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "PageHeader",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      required: false,
    }
  },
  data() {
    return {};
  },
  created() {
    document.title = `SevesoRec | ${this.title}`;
  },
  computed: {
    ...mapGetters({
      loggedInUser: "loggedInUser",
      commonData: "partners/commonData"
    }),
    needSubTitle() {
      return this.title !== this.commonData.partner.name;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.main-title {
  font-size: 20px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/layouts/PageHeader.vue